export default "__VITE_ASSET__639de35c__"